var React = require('react');

function Pause (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"x":"7","y":"7","width":"7","height":"18","fillRule":"nonzero","key":0}),React.createElement("rect",{"x":"18","y":"7","width":"7","height":"18","fillRule":"nonzero","key":1})]);
}

Pause.defaultProps = {"viewBox":"0 0 32 32"};

module.exports = Pause;

Pause.default = Pause;
